
import { combineReducers } from 'redux' ;
import auth from './auth'; 
import cart from './cart';
 import productDetails from "./productDetails"; 
 import product from "./product"; 
 export default combineReducers(
    { auth, cart, productDetails, product }
);
        